import React from "react";
import Footer from "../components/Footer";
import "./Services.css";
import labTest from "../asset/images/LabTests.avif";
import bloodBanks from "../asset/images/Blood Banks.avif";
import Diogonstic from "../asset/images/Diogonstic.avif";
import Medicine from "../asset/images/MedicineDeliveries.avif";
import headlthcareServicesOnline from "../asset/images/healthcareServicesOnline.avif";
import { Card } from "antd";
import "./Home.css";
const { Meta } = Card;

const ServiceSectionWithCards = ({ cardsData }) => {
  return (
    <div className="service-section-container">
      {cardsData.map((card, index) => (
        <Card
          hoverable
          className="service-card"
          cover={<img src={card.image} alt={card.header} />}
        >
          <div className="card-content-container">
            <h2 className="card-header">{card.header}</h2>
            <p
              className="card-content"
              style={{
                color: "gray",
                lineHeight: "1.5rem",
                fontSize: "1.3rem",
              }}
            >
              {card.content}
            </p>

            {/* Render subheading and subheading values if present */}
            {card.subheading && (
              <>
                <h3 className="card-subheading">{card.subheading}</h3>
                <ul
                  className="card-subheading-values"
                  style={{
                    listStyle: "none",
                    fontSize: "1.2rem",
                    marginBottom: "10px",
                  }}
                >
                  {card.subHeadingValues.map((value, idx) => (
                    <li key={idx}>{value}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </Card>
      ))}
      {/* {cardsData.map((card, index) => (
        <div key={index} className="card">
          <img src={card.image} alt={card.header} className="card-image" />
          <h2 className="card-header">{card.header}</h2>
          <p
            className="card-content"
            style={{ color: "gray", lineHeight: "1.5rem", fontSize: "1.3rem" }}
          >
            {card.content}
          </p>
          {card.subheading && (
            <>
              <h3 className="card-subheading">{card.subheading}</h3>
              <ul
                className="card-subheading-values"
                style={{
                  listStyle: "none",
                  fontSize: "1.2rem",
                  marginBottom: "10px",
                }}
              >
                {card.subHeadingValues.map((value, idx) => (
                  <li key={idx}>{value}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      ))} */}
    </div>
  );
};
const Services = () => {
  const cardsData = [
    {
      image: labTest,
      header: "Lab Tests",
      subheading: "E-reports within Few hours of Sample Collection.",
      subHeadingValues: [
        "Fever profile",
        "Blood infection",
        "Diabetes",
        "Full body check-up",
        "Nutrition check-up",
        "Liver check-up",
        "Kidney tests",
        "Hormones",
      ],
      content:
        "Home sample collection. Safe & hygienic practices. Partnered with certified labs for accurate results. Trained phlebotomists for home sample collection. Compare test prices of nearby labs.",
    },
    {
      image: Medicine,
      header: "Medicine Deliveries",
      subheading: "Categories.",
      subHeadingValues: [
        "Vitamin supplements",
        "Personal care",
        "Cough & cold",
        "Diabetic care",
        "Healthy snacks",
        "Digestive care",
        "Skin care",
        "Hair care",
        "Sexual health",
        "Pain relief",
        "Nutritional drinks",
        "First aid",
      ],
      content:
        "We provide a complete range of pharmaceutical products & health essentials delivered to your doorstep. Explore our services designed to make healthcare more accessible & convenient. Order Prescription Medications with Ease: Upload your prescription & we will take care of the rest. Over-the-Counter Medicines: Find everyday essentials like pain relievers, antacids & more. Auto Refill Subscriptions: For regular medications like diabetes medicines, thyroid medicines.",
    },
    {
      image: Diogonstic,
      header: "Diagnostic Imaging Centers",
      subheading: "Categories.",
      subHeadingValues: [
        "MRI (Magnetic Resonance Imaging)",
        "CT (Computed Tomography) scans",
        "Ultrasound Imaging",
        "Mammography",
        "PET Scans",
        "Colon Doppler",
        "Fluoroscopy",
        "Angiography",
        "Echocardiography",
        "DEXA Scan",
      ],
      content:
        "Find a diagnostic center near you. Book your imaging appointment. Compare prices of/on diagnostic imaging tests near you. Map view & full address for easy center location/search. Fast & accurate results/reports delivered online or at the center to you",
    },
    {
      image: bloodBanks,
      header: "Blood Banks",
      content:
        "Registration for voluntary blood donation. Updates of blood donation camps. Real-time blood availability status. Matching blood groups with ease. Trusted by hospitals & healthcare providers",
    },
  ];
  return (
    <div className="service-container">
      <h1 className="section-title">Healthcare Services</h1>
      <p style={{ color: "gray", fontSize: "1.3rem" }}>
        Access medical services easily with Abomed, your healthcare provider
        right at your fingertips.
      </p>
      <div className="service-content-section">
        <ServiceSectionWithCards cardsData={cardsData} />
      </div>
      <Footer />
    </div>
  );
};

export default Services;
